import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useInterval } from 'usehooks-ts';

function useCookieWatcher(cookieName: string, pollingInterval: number = 1000, onChange?: (oldCookieValue: string | undefined, newCookieValue: string | undefined) => void) {
  const [cookieValue, setCookieValue] = useState<string | undefined>(Cookies.get(cookieName));

  // Function to dispatch a custom event when the cookie value changes
  function dispatchCookieChangeEvent(oldCookieValue: string | undefined, newCookieValue: string | undefined) {
    const event = new CustomEvent('cookieChange', { detail: { cookieName, oldCookieValue, newCookieValue } });
    window.dispatchEvent(event);  // Dispatching the event globally
    if (onChange) {
      onChange(oldCookieValue, newCookieValue);  // Call the callback function provided by the user
    }
  }

  useInterval(() => {
    const currentCookieValue = Cookies.get(cookieName);
    //      console.log(`${currentCookieValue}:${cookieValue}`);
          if (currentCookieValue !== cookieValue) {
            console.log("Cookie cheange detected.... " + cookieValue + ":" + currentCookieValue);
            setCookieValue(currentCookieValue); // Cookie has changed
            dispatchCookieChangeEvent(cookieValue, currentCookieValue); // Dispatch event on change
          }
  }, pollingInterval);

  return cookieValue;
}

export default useCookieWatcher;
